import { useAuth } from "./auth/AuthContext";

import { useSettingStore } from "./stores/settingStore";
import { useSessionStore } from "./stores/sessionStore";

import { ReactComponent as HomeIcon } from "./assets/icons/home-1-svgrepo-com.svg";
import { ReactComponent as CustomerIcon } from "./assets/icons/user-circle-svgrepo-com.svg";
import { ReactComponent as UserIcon } from "./assets/icons/settings-svgrepo-com.svg";

import Index from "./views/Index";
import User from "views/User";
import Customer from "views/Customer";
import AddCustomer from "views/AddCustomer";
import EditCustomer from "views/EditCustomer";
import ReportCustomer from "views/ReportCustomer";
import AddReportCustomer from "views/AddReportCustomer";
import Report from "views/Report";

export const useRoutes = () => {
  const { user } = useAuth();

  return [
    {
      path: "/customer-report",
      name: "Customers & Report",
      icon: <CustomerIcon />,
      component: <Customer />,
    },
    {
      path: "/add-customer",
      name: "ข้อมูลลูกค้า",
      component: <AddCustomer />,

      hidden: true,
    },
    {
      path: "/edit-customer",
      name: "ข้อมูลลูกค้า",
      component: <EditCustomer />,

      hidden: true,
    },
    {
      path: "/report-customer",
      name: "ข้อมูลลูกค้า",
      component: <ReportCustomer />,
      hidden: true,
    },
        {
      path: "/add-report-customer",
      name: "ข้อมูลลูกค้า",
      component: <AddReportCustomer />,
      hidden: true,
    },
    {
      path: "/user",
      name: "Users",
      icon: <UserIcon />,
      component: <User />,
    },
    // {
    //   path: "/report",
    //   name: "Add Field Report",
    //   icon: <UserIcon />,
    //   component: <Report />,
    // },
  ];
};
